import { RouteConfig } from 'vue-router'

import { useSystemStore } from '@/client/store/useSystemStore'

import TwBenchmark from './pages'

export const twBenchmarks: RouteConfig = {
  component: TwBenchmark,
  path: '/twitter_benchmark_analytics/:postId(\\d+)?',
  name: 'tw_benchmarks',
  beforeEnter(to, from, next) {
    const systemStore = useSystemStore()
    if (!systemStore.currentGroup?.allowBenchmarkAnalytics) {
      return next('/campaigns')
    }
    next()
  }
}
